import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaLock, FaSignInAlt, FaSyncAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';
import Heading from '../components/common/Heading';
import Section from '../components/common/Section';
import { fetchAdminDashboard } from '../services/registrationService';
import { setAdminToken } from '../utils/adminAuth';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const normalizedToken = token.trim();

    if (!normalizedToken) {
      setError('Enter the admin access token.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await fetchAdminDashboard(normalizedToken);
      setAdminToken(normalizedToken);
      navigate('/admin', { replace: true });
    } catch (requestError) {
      if (!requestError.response) {
        setError('Unable to reach the admin API. Check REACT_APP_API_URL, backend deployment, and CORS settings.');
      } else {
        setError(requestError.response?.data?.message || 'Invalid admin token.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Login - Afrovate Tech Hub</title>
      </Helmet>

      <Section background="white" padding="lg">
        <div className="min-h-[70vh] flex items-center justify-center">
          <form onSubmit={handleSubmit} className="w-full max-w-md border border-gray-200 rounded-lg bg-white shadow-sm p-8">
            <div className="bg-primary bg-opacity-10 h-14 w-14 rounded-full flex items-center justify-center mb-5">
              <FaLock className="text-primary text-2xl" />
            </div>
            <Heading level={2} className="mb-2">Admin Login</Heading>
            <p className="text-gray-600 mb-6">Enter your admin access token to continue.</p>

            <label htmlFor="adminToken" className="block mb-2 text-sm font-medium text-gray-800">
              Access Token
            </label>
            <input
              id="adminToken"
              type="password"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Enter admin token"
            />

            {error && <p className="text-red-600 mt-3">{error}</p>}

            <Button
              type="submit"
              variant="primary"
              fullWidth
              className="mt-6"
              disabled={loading}
              icon={loading ? <FaSyncAlt className="animate-spin" /> : <FaSignInAlt />}
            >
              {loading ? 'Checking...' : 'Login'}
            </Button>
          </form>
        </div>
      </Section>
    </>
  );
};

export default AdminLoginPage;
